import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { store } from 'redux-rest-reducer';
import Humanize from 'humanize-plus';

import { Header } from 'semantic-ui-react';

import { getAll as getPrograms } from 'actions/curriculum-search';
import { openModal, closeModal } from 'actions/modal';
import { Separator, Row, Col, Button, Text } from '@cuemath/comps';
import { post as postAddTag, patch as patchExistingTag } from 'actions/curriculum-tags';
import { HeaderHead, Message, renderFormField } from 'modules/form';

import { addFilterFields, getInputChangeMethod, getOnChangeMethod } from 'constants/form';

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 0px 10px 10px 10px;
  margin-top: 10px;
  bottom: 5px;
  position: relative;
`;

export const FieldWrapper = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DeleteStyle = styled.div`
  margin-left: 15px;
`;

const ColWidth = styled(Col)`
  width: 300px;
`;

const PLACEHOLDER = {
  topic: {
    name: 'eg. Lines and Angles',
    code: 'eg. LINANG',
  },
  board: {
    name: 'eg. CBSE Grade 7',
    code: 'eg. CBSE.G7',
  },
  activity_topic: {
    name: 'eg. Lines and Angles',
    code: 'eg. LINANG',
  },
  activity_tile: {
    name: 'eg. Abacus',
    code: 'eg. LINANG',
  },
};

const TYPE = {
  board: 'Board',
  topic: 'Topic',
  activity_topic: 'Activity Topic',
  activity_tile: 'Activity Tile',
};

const SEARCH_TYPE = {
  board: 'boards',
  topic: 'topics',
  activity_topic: 'Activity Topic',
  activity_tile: 'Activity Tile',
};

const ACTIONS = {
  PATCH: 'UPDATE',
  DELETE: 'DELETE',
};

class AddFilter extends PureComponent {
  static defaultProps = {
    student: null,
    filterArray: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      errorText: null,
      message: null,
      tagPost: store.post(),
      tagPatch: store.patch(),
      form: this.getFormDefaults(),
      formFields: this.getFormFields(),
      submitDone: false,
      onDelete: false,
    };

    addFilterFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static propTypes = {
    actions: PropTypes.shape({
      postAddTag: PropTypes.func.isRequired,
      patchExistingTag: PropTypes.func.isRequired,
      getPrograms: PropTypes.func.isRequired,
    }).isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    const { curriculumTags, editType, curriculumSearch, editData } = props;
    const { tagPost, tagPatch, onDelete } = state;
    const { data } = editData || {};
    let obj = {};

    obj[`${SEARCH_TYPE[editType]}`] = data && data.name;
    obj.per_page = 0;

    const programsGet = store.getAll(curriculumSearch, obj);
    const postTags = store.post(curriculumTags, tagPost.id);
    const patchTags = store.patch(curriculumTags, tagPatch.id);

    const newState = {};

    if (programsGet && programsGet.isLoaded && programsGet.data) {
      newState.totalLinkedSheets =
        programsGet && programsGet.data && programsGet.data.total_results;
    }

    if (postTags.resolved) {
      if (postTags.resolved.isCreated) {
        newState.error = '';
        newState.submitDone = true;
        newState.message = `${TYPE[editType]} Added.`;
      } else if (postTags.resolved.isCreatingFailed) {
        newState.message = '';
        newState.submitDone = false;
        newState.errorText = store.getError(postTags.resolved)
          ? store.getError(postTags.resolved).message
          : 'Error';
      }
    }

    if (patchTags.resolved) {
      if (patchTags.resolved.isPatched) {
        newState.error = '';
        newState.message = onDelete
          ? `${TYPE[editType]} Deleted.`
          : `${TYPE[editType]} Updated.`;
        newState.submitDone = true;
      } else if (patchTags.resolved.isPatchingFailed) {
        newState.message = '';
        newState.submitDone = false;
        newState.errorText = store.getError(patchTags.resolved)
          ? store.getError(patchTags.resolved).message
          : 'Error';
      }
    }

    return newState;
  }

  onCloseModal = () => {
    const { actions } = this.props;

    actions.closeModal();
  };

  getFormDefaults = () => {
    const { editData } = this.props;
    const { data } = editData || {};
    const formDefaults = {};
    console.log(editData);
    addFilterFields.forEach(field => {
      formDefaults[field.name] =
        data && data[field.param] ? data[field.param] : field.default;
    });

    return formDefaults;
  };

  componentDidMount() {
    this.getFormDefaults();
  }

  componentDidUpdate(props, prevState) {
    const { refreshData } = this.props;
    const { submitDone } = this.state;
    const { submitDone: prevSubmitDone } = prevState || {};

    if (submitDone !== prevSubmitDone) {
      refreshData();
      if (submitDone) {
        this.timeout = setTimeout(() => {
          this.onCloseModal();
        }, 3000);
      }
    }
  }

  getFormFields = () => {
    return addFilterFields.map(field => {
      return field;
    });
  };

  onDeleteClicked = () => {
    const { actions, editData, editType } = this.props;
    const { onDelete } = this.state;
    const { data } = editData || {};

    let obj = {};
    obj[`${SEARCH_TYPE[editType]}`] = data && data.name;
    obj.per_page = 0;

    if (!onDelete) {
      actions.getPrograms(obj);
    }

    this.setState({ onDelete: !onDelete });
  };

  onSubmit = event => {
    event.preventDefault();
    this.removeMessage();
    this.removeErrors();
    this.onSubmitForm();
  };

  removeMessage = () => {
    const { message } = this.state;
    if (message) this.setState(() => ({ message: null }));
  };

  removeErrors = () => {
    const { errorText } = this.state;
    if (errorText) this.setState(() => ({ errorText: null }));
  };

  onChange = (key, value) => {
    const { form } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    const stateChanges = { form: newForm };
    this.setState(() => ({ ...stateChanges }));
  };

  onToggle = event => {
    const { form, errorText } = this.state;
    const key = event.target.name;
    const value = event.target.checked;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  renderFormFields = () => {
    const { formFields, form } = this.state;
    const { editType } = this.props;

    return (
      <FieldWrapper>
        {formFields.map((field, index) => {
          field.profileView = true;
          const disabled = field.disabled || !field.editable;
          const required = field.required;
          let placeholder = '';

          if (!disabled) {
            placeholder =
              field && !field.placeholder
                ? PLACEHOLDER[editType][field.name]
                : field.placeholder;
          }

          return (
            <div>
              <Separator height={10} transparent />{' '}
              {renderFormField({
                ...field,
                profileForm: true,
                value: !form[field.name] ? formFields[field.name] : form[field.name],
                onChange: this[getInputChangeMethod(field)],
                required,
                maxlength: field.maxlength,
                disabled,
                placeholder,
              })}
              <Separator height={10} transparent />
            </div>
          );
        })}
      </FieldWrapper>
    );
  };

  renderFormHeader = () => {
    const { isEdit, editType } = this.props;

    return (
      <HeaderHeadWrapper>
        <Header as="h3" floated="left">
          <Separator transparent height={5} />
          {!isEdit && (
            <Text weight="bold" color="rgba(0,0,0,.87)">
              Add a {TYPE[editType]}
            </Text>
          )}
          {!!isEdit && (
            <Text weight="bold" color="rgba(0,0,0,.87)">
              Edit a {TYPE[editType]}
            </Text>
          )}
        </Header>
      </HeaderHeadWrapper>
    );
  };

  canDisableButton = () => {
    const { form } = this.state;
    const { name, description } = form || {};

    if (!name || !description) {
      return true;
    }

    return false;
  };

  onSubmitForm = type => {
    const { actions, editType, isEdit, editData } = this.props;

    const { data } = editData || {};

    const {
      form,
      tagPost: { id },
      tagPatch: { id: patchId },
    } = this.state;
    const { name, description, enabled } = form || {};
    const postObj = {
      name: name,
      type: editType.toUpperCase(),
      description: description,
      is_live: enabled,
    };

    if (type === ACTIONS.DELETE) {
      const patchDelete = {
        action: ACTIONS.DELETE,
        action_data: {},
      };
      actions.patchExistingTag(patchId, data.id, patchDelete);
    } else {
      if (isEdit) {
        postObj.is_deleted = false;
        const patchObj = {
          action: ACTIONS.PATCH,
          action_data: postObj,
        };
        actions.patchExistingTag(patchId, data.id, patchObj);
      } else {
        actions.postAddTag(id, postObj);
      }
    }
  };

  render() {
    const { errorText, message, onDelete, totalLinkedSheets } = this.state;
    const { isEdit, editType } = this.props;

    const isButtonDisabled = this.canDisableButton();

    return (
      <FormWrapper>
        {this.renderFormHeader()}
        {message && <Message>{message}</Message>}
        <Separator transparent height={30} />
        {this.renderFormFields()}
        {errorText && <Message error={true}>{errorText}</Message>}
        <Separator transparent height={20} />
        {!onDelete && (
          <Row justifyContent="center">
            <Button
              label="Save"
              onClick={this.onSubmitForm}
              disabled={isButtonDisabled}
            />
            <DeleteStyle>
              {' '}
              {isEdit && <Button label="Delete" onClick={this.onDeleteClicked} />}
            </DeleteStyle>
          </Row>
        )}
        {onDelete && (
          <ColWidth justifyContent="center" alignItems="center">
            {totalLinkedSheets ? (
              <Text align="center">
                {totalLinkedSheets} {Humanize.pluralize(totalLinkedSheets, 'sheet')}{' '}
                {totalLinkedSheets > 1 ? 'are' : 'is'} tagged into this{' '}
                {TYPE[editType].toLowerCase()}. Deleting will remove the{' '}
                {TYPE[editType].toLowerCase()} tag from{' '}
                {totalLinkedSheets > 1 ? 'these' : 'this'}{' '}
                {Humanize.pluralize(totalLinkedSheets, 'sheet')}.
              </Text>
            ) : (
              ''
            )}
            <Separator transparent height={10} />
            <Text>Are you sure you want to delete this {TYPE[editType]}?</Text>
            <Separator transparent height={20} />
            <Row justifyContent="center">
              {isEdit && (
                <Button label="Delete" onClick={() => this.onSubmitForm('DELETE')} />
              )}
              <DeleteStyle>
                <Button label="Cancel" onClick={this.onDeleteClicked} />
              </DeleteStyle>
            </Row>
          </ColWidth>
        )}
        <Separator transparent height={30} />
      </FormWrapper>
    );
  }
}

export default connect(
  ({ curriculumSearch, curriculumTags }) => ({
    curriculumTags,
    curriculumSearch,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
        closeModal,
        postAddTag,
        patchExistingTag,
        getPrograms,
      },
      dispatch,
    ),
  }),
)(AddFilter);
